<template>

  <div style="margin-top: 7vw">
    <!-- New Section with Red Box and Text -->

    <!-- Drug Section -->
    <div id="drug">
      <div style="height: 4vw;background-color: #c7bc9b;color: black;position: relative;width: 100vw">
        <span style="font-size: 2vw;position: absolute;left: 2%;bottom: 10%;font-weight: bolder">Drug</span>
      </div>
    </div>
    <div id="drugContent" class="drug-section"  style="position: relative">
      <div class="el-row" style="width: 100vw">
        <div class="el-col-6">
          <img src="./About/chiglitazar_chemical.png" alt="Cohort" style="width: 90%">
        </div>
        <div class="el-col-18" style="display: flex;justify-content: center;align-items: center">
          <div style="text-align: justify;padding: 0vw 1.5vw" class="section-text">
            <span  class="section-text-highlight"><strong>Chiglitazar<a href="https://www.chipscreen.com/en/products/699.html">🔗</a></strong></span>
            , also known as Carfloglitazar (Bilessglu<sup>®</sup>), is an orally administered, non-thiazolidinedione small-molecule agonist of α, δ and γ peroxisome proliferator-activated receptors (PPARs) being developed by Chipscreen Biosciences<a href="https://www.chipscreen.com/en/">🔗</a>. Since October 2021, Chiglitazar has been approved in China for use as an adjunct to diet and exercise to improve glycemic control in adult patients with T2D, and is also in phase 2 clinical development for the treatment of metabolic dysfunction-associated steatohepatitis (MASH).
          </div>
        </div>

        <div class="el-col-10">
          <div>
            <p class="section-text-highlight"><strong>Pharmacodynamics</strong></p>
            <p style="text-align: justify;" class="section-text">
              Chiglitazar displayed balanced activity across three PPAR subtypes, and induces the expression of various downstream target genes, including genes involved in insulin sensitivity, lipid metabolism/transport, thermogenesis and energy conversion<a href="https://doi.org/10.1155/2012/546548">🔗</a>. Chiglitazar also inhibited PPARγ phosphorylation<a href="https://doi.org/10.1155/2017/4313561">🔗</a>.
            </p>

          </div>
        </div>
        <div class="el-col-14">
          <img src="./About/chiglitazar_ppar.png" alt="Cohort" style="width: 100%;">
        </div>

        <div class="el-col-24">
          <div style="width: 100%;text-align: center; margin-top: 1vw ;" class="section-text-highlight">
            <span><strong>Milestones</strong></span>
          </div>

          <v-timeline direction="horizontal" >
            <v-timeline-item>
              <template v-slot:opposite>
                <p class="time-text"><strong>2014.06</strong></p>
              </template>
              <div class="event-describ">
                <p><strong>CMAP (NCT02121717)</strong></p>
                <div class="event-describ-text">
                  <p>Multicenter, Randomized</p>
                  <p>Double-Blind, Placebo Controlled</p>
                  <p>Phase 3 Trial in</p>
                  <p>Patients with T2D<a href="https://clinicaltrials.gov/study/NCT02121717">🔗</a></p>
                </div>
              </div>
            </v-timeline-item>
            <v-timeline-item>
              <template v-slot:opposite>
                <p class="time-text"><strong>2014.09</strong></p>
              </template>
              <div class="event-describ">
                <p><strong>CMAS (NCT02173457)</strong></p>
                <div class="event-describ-text">
                  <p>Multicenter, Randomized</p>
                  <p>Double-Blind, Sitagliptin Controlled</p>
                  <p>Phase 3 Trial in</p>
                  <p>Patients with T2D<a href="https://clinicaltrials.gov/study/NCT02173457">🔗</a></p>
                </div>
              </div>
            </v-timeline-item>
            <v-timeline-item>
              <template v-slot:opposite>
                <p class="time-text"><strong>2019.09</strong></p>
              </template>
              <div class="event-describ" style="background-color: #f1d0d3;">
                <p><strong>New Drug Application (NDA)</strong></p>
                <p><strong>accepted in China</strong></p>
              </div>
            </v-timeline-item>
            <v-timeline-item>
              <template v-slot:opposite>
                <p class="time-text"><strong>2021.05</strong></p>
              </template>
              <div class="event-describ">
                <p><strong>RECAM</strong></p>
                <p><strong>(NCT04807348)</strong></p>
                <div class="event-describ-text">
                  <p>Randomized, Double-Blind,</p>
                  <p>Placebo Controlled Phase 3 Trial</p>
                  <p>of Chiglitazar Added to Metformin</p>
                  <p>in Patients with T2D<a href="https://clinicaltrials.gov/study/NCT04807348">🔗</a></p>
                </div>
              </div>
            </v-timeline-item>
            <v-timeline-item>
              <template v-slot:opposite>
                <p class="time-text"><strong>2021.10</strong></p>
              </template>
              <div style="background-color: #f1d0d3;" class="event-describ">
                <p><strong>Approved in China</strong></p>
              </div>
            </v-timeline-item>
            <v-timeline-item>
              <template v-slot:opposite>
                <p class="time-text"><strong>2022.03</strong></p>
              </template>
              <div class="event-describ">
                <p><strong>CGZ203 (NCT05193916)</strong></p>
                <div class="event-describ-text">
                  <p>Multi-Center, Randomized,</p>
                  <p>Double-Blind, Placebo Controlled</p>
                  <p>Phase 2 Trial in</p>
                  <p>Patients with NASH<a href="https://clinicaltrials.gov/study/NCT05193916">🔗</a></p>
                </div>
              </div>
            </v-timeline-item>
          </v-timeline>

        </div>
      </div>



    </div>

    <!-- Cohort Section -->
    <div id="cohort">
      <div style="height: 4vw;background-color: #5e4c3e;color: black;position: relative;width: 100vw;color:white">
        <span style="font-size: 2vw;position: absolute;left: 2%;bottom: 10%;font-weight: bolder">Cohort</span>
      </div>
    </div>
    <div id="cohortContent" class="cohort-section el-row">
      <div class="el-col-24" style="margin-top: 1.5vw">
        <p style="text-align: justify;" class="section-text">
          <strong class="section-text-highlight">Our cohort</strong> consisting 835 drug-naïve patients with T2D were recruited from two randomized, double-blind, phase 3 trials of Chiglitazar. The placebo-controlled CMAP trial (NCT02121717, ClinicalTrials.gov) included 350 patients randomly assigned to receive low dose (32 mg/day, n = 106), high dose (48 mg/day, n = 106) Chiglitazar and placebo (n = 138) for treatment. The Sitagliptin-controlled CMAS trial (NCT02173457, ClinicalTrials.gov) included 485 patients randomly assigned to receive low dose (n = 161), high dose (n = 161) Chiglitazar and Sitagliptin (n = 163) for treatment.
        </p>
      </div>
      <div class="el-col-24">
        <img src="./cohort.png" alt="Cohort" class="full-width-image" style="width: 90%">
      </div>

    </div>

    <!-- Omics Section -->
    <div id="omics">
      <div style="height: 4vw;background-color: #c7bc9b;color: black;position: relative;width: 100vw">
        <span style="font-size: 2vw;position: absolute;left: 2%;bottom: 10%;font-weight: bolder">Data</span>
      </div>
    </div>
    <div id="omicsContent" class="omics-section">
        <div class="el-row">
          <div class="el-col-8">
            <img src="./About/omics.png" alt="Omics" class="full-width-image" style="width: 90%">
          </div>
          <div class="el-col-16">
            <div style="text-align: justify;margin-top: 2vw" class="section-text">
              <p><strong class="section-text-highlight">Multi-omics datasets</strong> were generated from longitudinally collected blood samples (n = 2,390) of patients at baseline, treated for 12 weeks and 24 weeks during trials. Specifically, genomic and methylomic data were generated from whole blood samples at baseline, whereas miRNAomic, proteomic and metabolomic data were generated from plasma samples at different time points.</p>
              <p style="margin-top: 2vw"><strong style="font-size: 1.7vw">Stringent quality control (QC) procedures</strong> were implemented to generate high-quality multi-omics datasets.</p>
            </div>
          </div>
        </div>
    </div>


    <div id="team">
      <div style="height: 4vw;background-color: #5e4c3e;color: black;position: relative;width: 100vw;color:white">
        <span style="font-size: 2vw;position: absolute;left: 2%;bottom: 10%;font-weight: bolder">Team</span>
      </div>

    </div>
    <div id="teamContent" class="team-section" align="top" >
      <div class="sub-container">
        <h1 style="font-size: 3vw">Members</h1>
        <div class="people-container">
          <div class="people el-col-5" v-for="(item, index) in teamMembers" :key="index">
            <a :href="item.link"><img  loading="lazy" class="avatar avatar-circle hvr-grow-shadow" :src="item.img"  ></a>
            <div class="portrait-title">
              <p style="font-size: 1.3vw;margin-top: 0.4vw;color: #3c90ff">{{item.name}}</p>
              <p style="font-size: 1vw;opacity: 0.6;margin-top: 0.2vw">{{item.institution}}</p>
              <p style="font-size: 1vw;opacity: 0.6;margin-top: 0.2vw">{{item.title}}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="sub-container">
        <h1 style="font-size: 3vw">Advisors</h1>
        <div class="people-container">
          <div class="people el-col-5" v-for="(item, index) in advisors" :key="index">
<!--              <p ><a :href="item.link">🔗</a></p>-->
            <a :href="item.link"><img  loading="lazy" class="avatar avatar-circle hvr-grow-shadow" :src="item.img"  ></a>
            <div class="portrait-title">
              <p style="font-size: 1.3vw;margin-top: 0.4vw;color: #3c90ff">{{item.name}}</p>
              <p style="font-size: 1vw;opacity: 0.6;margin-top: 0.2vw">{{item.institution}}</p>
              <p style="font-size: 1vw;opacity: 0.6;margin-top: 0.2vw">{{item.title}}</p>
            </div>
          </div>
        </div>
      </div>
    </div>

  </div>

</template>

<script>
// import { useRoute } from 'vue-router'
//
// const route = useRoute()

export default {
  name: "cAbout",
  components:{

  },
  props:{
    location:{
      type:String,
      required: true
    }
  },

  data() {
    return {
      teamMembers:[
        {
          img:'./About/members/YuantingZheng.jpg',
          name:'Yuanting Zheng',
          title:'Professor',
          institution: 'Fudan University',
          department: 'State Key Laboratory of Genetic Engineering, Human Phenome Institute and School of Life Sciences, Shanghai Cancer Center, Ph.D.',
          email:'zhengyuanting@fudan.edu.cn',
          research:'Development of multi-omics standard materials and standard reference data, Multi-omics-driven pharmacogenomics and phenomics',
          link:'https://life.fudan.edu.cn/67/3f/c28175a354111/page.htm'
        },
        {
          img:'./About/members/ZehuiCao.jpg',
          name:'Zehui Cao',
          title:'PhD candidate (2020-)',
          institution: 'Fudan University',
          department: 'State Key Laboratory of Genetic Engineering, Human Phenome Institute and School of Life Sciences, Shanghai Cancer Center',
          email:'20110700029@fudan.edu.cn',
          research:'Multi-omics and pharmacogenomics studies in metabolic diseases aiming to reveal disease mechanism and realize precision medicine',
          link:'http://139.224.221.28/member',
        },
        {
          img:'./About/members/NaixinZhang.jpg',
          name:'Naixin Zhang',
          title:'Postdoc',
          institution: 'University of Copenhagen',
          department: 'Department of Public Health and Novo Nordisk Foundation Center for Basic Metabolic Research',
          email:'naixin.zhang@sund.ku.dk',
          research:'Diet, Multiomics, Cardiometabolic diseases',
          link:'http://139.224.221.28/member',
        },
        {
          img:'./About/members/HaonanChen.jpg',
          name:'Haonan Chen',
          title:'Master candidate (2023-)',
          institution: 'Fudan University',
          department: 'State Key Laboratory of Genetic Engineering, Human Phenome Institute and School of Life Sciences, Shanghai Cancer Center',
          email:'23210700119@m.fudan.edu.cn',
          research:'Deep learning, Multi-omics integration, Precision medicine, Bioinformatics',
          link:'http://139.224.221.28/member',
        },
        {
          img:'./About/members/JiaqiLi.jpg',
          name:'Jiaqi Li',
          title:'PhD candidate (2023-)',
          institution: 'Fudan University',
          department: 'State Key Laboratory of Genetic Engineering, Human Phenome Institute and School of Life Sciences, Shanghai Cancer Center',
          email:'23110700029@m.fudan.edu.cn',
          research:'Omics-driven target discovery and validation, Bioinformatics, Precision medicine',
          link:'http://139.224.221.28/member',
        },
        {
          img:'./About/members/QiaochuChen.jpg',
          name:'Qiaochu Chen',
          title:'PhD candidate (2021-)',
          institution: 'Fudan University',
          department: 'State Key Laboratory of Genetic Engineering, Human Phenome Institute and School of Life Sciences, Shanghai Cancer Center',
          email:'21112030002@m.fudan.edu.cn',
          research:'Quality control and integrative analysis of large-scale proteomics and metabolomics',
          link:'http://fudan-pgx.org/#/author?name=Qiaochu+Chen',
        },
        {
          img:'./About/members/YuanbangMai.jpg',
          name:'Yuanbang Mai',
          title:'PhD candidate (2022-)',
          institution: 'Fudan University',
          department: 'State Key Laboratory of Genetic Engineering, Human Phenome Institute and School of Life Sciences, Shanghai Cancer Center',
          email:'22110700133@m.fudan.edu.cn',
          research:'Biostatistics, Data mining, Multiomics Integration',
          link:'http://139.224.221.28/member',
        },
        {
          img:'./About/members/YuyangZhu.jpg',
          name:'Yuyang Zhu',
          title:'PhD candidate (2024-)',
          institution: 'Fudan University',
          department: 'State Key Laboratory of Genetic Engineering, Human Phenome Institute and School of Life Sciences, Shanghai Cancer Center',
          email:'2020200569@stu.cpu.edu.cn',
          research:'Metabolomics, Computational analysis and Software development, Multi-Omics and Integrative analysis',
          link:'http://139.224.221.28/member',
        },
      ],

      advisors:[
          {
            img:'./About/members/LemingShi.jpg',
            name:'Leming Shi',
            title:'Professor',
            institution: 'Fudan University',
            department: 'State Key Laboratory of Genetic Engineering, Human Phenome Institute and School of Life Sciences, Shanghai Cancer Center, International Human Phenome Institutes (Shanghai), Ph.D',
            email:'lemingshi@fudan.edu.cn',
            research:'Pharmacogenomics, Precision Medicine, Medical Big Data, Bioinformatics, Cheminformatics',
            link:'https://life.fudan.edu.cn/91/70/c28177a299376/page.htm',
          },
          {
            img:'./About/members/XianpingLu.jpg',
            name:'Xianping Lu',
            title:'Founder, Chairman, President',
            institution: 'Chipscreen Biosciences',
            department: 'State Key Laboratory of Membrane Biology at Tsinghua University, Ph.D',
            email:'BD@chipscreen.com',
            research:'Pharmacogenomics, Precision Medicine, Medical Big Data, Bioinformatics, Cheminformatics',
            link:'https://www.chipscreen.com/en/about?#about-2'
          },

      ],

    };
  },
  methods: {
    scrollToTop() {
      window.scrollTo({
        top: 0,
        behavior: 'smooth'
      });
    },

    go(selector) {
      const element = document.querySelector(selector);
      if (element) {
        element.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      } else {
        console.error(`Element with selector "${selector}" not found.`);
      }
    }
  },

  mounted() {
   let _this = this
    const location = this.$route.query.location
    this.$nextTick(() => {
      setTimeout(() => {
        _this.go(location);
      }, 1); // 延迟500毫秒
    });
  },

  watch: {
    '$route.query.location'(newLocation) {
      this.$nextTick(() => {
        setTimeout(() => {
          this.go(newLocation);
        }, 1); // 延迟1毫秒
      });
    }
  }
}
</script>

<style scoped>
a {
  text-decoration: none;
  color: inherit;  /* 继承父元素的颜色 */
}
.full-width-image {
  width: 100%;
  height: auto;
  display: block;
  margin: 0 auto;
}

#drugContent, #cohortContent, #omicsContent {
  padding: 0 0;
  margin-bottom: 5vw;
  border-bottom: 0.2vw solid #ccc;
}

.drug-section {
  /*background-image: url("@/assets/about/chiglitazar_drug.jpg");*/
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;

  display: flex;
  /*align-items: center;*/
  /*justify-content: center;*/
  color: black; /* Optional, depending on your background image */
}

.cohort-section {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black; /* Optional, depending on your background image */
}

.omics-section {
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: auto;
  display: flex;
  align-items: center;
  justify-content: center;
  color: black; /* Optional, depending on your background image */
  margin-top: 3vw;
}

.team-section {
  /*background-image: url("@/assets/about/team.jpg");*/
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center;
  width: 100%;
  height: auto;
  /*display: flex;*/
  /*align-items: center;*/
  /*justify-content: center;*/
  /*color: black; !* Optional, depending on your background image *!*/
}



.chiglitazar-link {
  color: black;
  text-decoration: none; /* Remove underline if necessary */
  font-size: 2vw;
}

.chiglitazar-link:hover {

  text-decoration: underline;
  font-size: 2vw;
  color: #18adad; /* Set the link color to #2A7C92 */
}

.body-par{
  margin: 5vh 1vh 0vh 1vh;
  font-size: 3vh;
  line-height: 5vh;
  padding-left: 5vw;
  padding-right: 5vw;
}
.body-text {
  text-align: justify;
}

.sub-container {
  padding:1.5vw 0;
}

.people-container{
  justify-content: center;
  display: flex;
  flex-wrap: wrap;
}

.people {
  margin-top: 1.5vw;
}
.avatar {

  width: 12vw;
  height: 12vw;
  margin: 0 auto;
  object-fit: cover;
  cursor: pointer;
}


.avatar-circle {
  border-radius: 50%;
}

.portrait-title{
  padding-top: 0.3vw;
}

/* Grow Shadow */
.hvr-grow-shadow {
  display: inline-block;
  vertical-align: middle;
  -webkit-transform: translateZ(0);
  transform: translateZ(0);
  box-shadow: 0 0 0.1vw rgba(0, 0, 0, 0);
  -webkit-backface-visibility: hidden;
  backface-visibility: hidden;
  -moz-osx-font-smoothing: grayscale;
  -webkit-transition-duration: 0.3s;
  transition-duration: 0.3s;
  -webkit-transition-property: box-shadow, transform;
  transition-property: box-shadow, transform;
}
.hvr-grow-shadow:hover, .hvr-grow-shadow:focus, .hvr-grow-shadow:active {
  box-shadow: 0.8vw 0.8vw 0.4vw rgba(0, 0, 0, 0.2);
  -webkit-transform: scale(1.1);
  transform: scale(1.1);
}

.time-text {
 font-size: 1.4vw
}

.event-describ {
  text-align: center;
  background-color: #fcf0d2;
  padding: 1.2vw 0.4vw;
  font-size: 1.2vw;
  line-height: 1.4vw;
  width: 13vw
}

.event-describ-text{
  font-size: 0.9vw
}

.section-text {
  line-height: 3vw;font-size: 1.6vw;
}

.section-text-highlight {
  font-size: 1.7vw;
}

>>>.v-timeline-divider__dot--size-default  {
  height: 1.5vw !important;
  width: 1.5vw !important;
}
>>>.v-timeline-divider__inner-dot{
  height: 1.5vw !important;
  width: 1.5vw !important;
}

>>>.v-timeline--horizontal{
  width: 100vw !important;
}
>>>.v-timeline-divider{
  width: calc(100vw / 6) !important;
  --v-timeline-line-thickness:0.2vw;
}
>>>.v-timeline-divider__before{
  width: calc(100vw / 12) !important;
  inset-inline-start: 0vw !important;
  inset-inline-end:  calc(100vw / 12) !important;
}

>>>.v-timeline-divider__after{
  width:  calc(100vw / 12) !important;
  inset-inline-start:  calc(100vw / 12) !important;
  inset-inline-end:  calc(100vw / 6) !important;
}

>>>.v-timeline--horizontal {
  grid-column-gap: 0px !important;
}
>>>.v-timeline{
  grid-column-gap: 0px !important;
  max-width: 100vw !important;
}



>>> .v-timeline-item__body {
  padding-inline: 0vw !important;
  padding: 3vw 0 !important;
}

>>> .v-timeline-item__opposite{
  padding-inline: 0vw !important;
  padding: 2vw 0 !important;
}


</style>
